import api from "../api/api";

class PaisService {
    async getAllPaginate(search: string, page: string | null) {
        let q = '';
        if (search?.length > 0) {
            q = `?q=${search}`;
            q += page ? `&page=${page}` : "";
            return await api.get(`/pais${q}`).then(r => r.data).catch(err => err);
        } else {
            if (page) {
                return await api.get(`/pais?page=${page}`).then(r => r.data).catch(err => err);
            } else {
                return await api.get(`/pais`).then(r => r.data).catch(err => err);
            }
        }
    }

    async get(id: string) {
        return await api.get(`/pais/${id}`).then(response => response.data).catch(err => err);
    }

    async create(data: any) {
        return await api.post("/pais", data).then(response => response.data);
    }

    async update(id: string, data: any) {
        return await api.put(`/pais/${id}`, data).then(response => response.data);
    }

    async delete(id: string) {
        return await api.delete(`/pais/${id}`).then(response => response.data).catch(err => err);
    }
}

const paisService = new PaisService();

export default paisService;